<ng-template ngFor let-tab [ngForOf]="tabset.tabs">
    <div *ngIf="tab.isPanelInDom()" [hidden]="!tab.active">
        <ng-template
            [ngTemplateOutlet]="tab.contentTemplate?.templateRef || null"
            [ngTemplateOutletContext]="{ $implicit: tab.active }"
        ></ng-template>
    </div>
</ng-template>
